import { StepButtons } from '@/components/multistep/Questionnaire';
import { useCategories, useCreateCategory } from '@/services/api/hooks/catalog';
import { useCSV, useMap, useResult } from '@/services/csv/useCSVService';
import { Association } from '../../../../../components/bulkUpload/Association';
import { Result } from '../bulkUploadHelper';
import { Maps } from '../enum';
import { useMismatchedCategories } from '../helpers/getMismatched';

export const ReviewCategoriesStep = () => {
  const result = useResult<Result>();
  if (!result) throw Error('No result');
  const [categories] = useCategories();
  const createCategory = useCreateCategory();
  const uniqueAndNewCategories = useMismatchedCategories(result, categories);
  const addMapAssociation = useCSV(state => state.addMapAssociation);
  const categoryMap = useMap(Maps.Category);

  const canGoNext = uniqueAndNewCategories.reduce((acc, c) => {
    return acc && categoryMap?.[c] !== undefined;
  }, true);

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-3 gap-5">
        {uniqueAndNewCategories.map(m => (
          <Association
            key={m}
            incoming={m}
            options={categories}
            onCreate={async name => {
              await createCategory.mutateAsync({ name, description: '', isMainDevice: false });
            }}
            onAssociate={(incoming, choice) => {
              addMapAssociation(Maps.Category, incoming, choice.id);
            }}
            mapping={categoryMap?.[m]}
          />
        ))}
      </div>
      <StepButtons canGoNext={canGoNext} />
    </div>
  );
};
